export const getErrorMessage = (error: Error | any, fallbackMsg?: string): string => {
  const data = error?.response?.data;
  if (data && data.errors && typeof data.errors === 'object') {
    const messages = Object.values(data.errors)
      .flatMap((m) => (Array.isArray(m) ? m : []))
      .filter(Boolean) as string[];
    if (messages.length) {
      return messages.join('; ');
    }
  }
  if (error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }
  return error.message || fallbackMsg || 'An unknown error occurred';
};
